import * as Sentry from '@sentry/react';
import jwt_decode from 'jwt-decode';

export type JwtTokenParsed = {
    username: string;
    phone_number: string;
    sub: string;
    social_access_token: string;
};

export const parseJWT = (token: string): JwtTokenParsed => {
    try {
        const {
            username = '',
            phone_number = '',
            sub = '',
            social_access_token = '',
        } = jwt_decode<JwtTokenParsed>(token);

        return {
            username,
            phone_number,
            sub,
            social_access_token,
        };
    } catch (e) {
        Sentry.captureException(e);
        return {
            username: '',
            phone_number: '',
            sub: '',
            social_access_token: '',
        };
    }
};
